<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Create Transmittal</p>
        </header>

        <form :action="`/transmittal/${contact.id}/pdf`" method="POST" @submit="handleFormSubmit">
            <section class="modal-card-body">
                <input type="hidden" :value="project.id" name="project_id">

                <o-field label="We are sending you:">
                    <o-select v-model="form.docs" multiple native-size="9" expanded name="docs[]">
                        <option v-for="doc in docs" :value="doc" :key="doc">
                            {{ doc }}
                        </option>
                    </o-select>
                </o-field>

                <o-table v-if="form.other_docs.length"
                         class="is-responsive is-responsive-xs-desktop"
                         :data="form.other_docs"
                         :bordered="true"
                         :paginated="false"
                         :striped="true"
                >
                    <template>
                        <o-table-column #default="{ row, index }" label="Copies" :sortable="false" :width="50">
                            <o-field>
                                <o-input type="number" v-model="row.copies" :name="`other_docs[${index}][copies]`"/>
                            </o-field>
                        </o-table-column>

                        <o-table-column #default="{ row, index }" label="No." :sortable="false">
                            <o-field>
                                <o-select placeholder v-model="row.no" expanded :name="`other_docs[${index}][no]`">
                                    <option>-</option>
                                    <option v-for="a in applications" :value="applicationName(a)" :key="applicationName(a)">
                                        {{ applicationName(a) }}
                                    </option>
                                </o-select>
                            </o-field>
                        </o-table-column>

                        <o-table-column #default="{ row, index }" label="Description" :sortable="false">
                            <o-field class="column flex-column is-paddingless">
                                <o-select v-model="row.file_id" expanded class="normal-size mb-1" :disabled="!! row.description" :name="`other_docs[${index}][file_id]`">
                                    <option :value="null" disabled selected>Choose a file</option>
                                    <option v-for="f in files" :key="f.name" :value="f.id">{{ f.name }}</option>
                                </o-select>
                                <o-input v-model="row.description" :name="`other_docs[${index}][description]`" maxlength="200" type="textarea" placeholder="or specify a description"></o-input>
                            </o-field>
                        </o-table-column>

                        <o-table-column #default="{ row, index }" :sortable="false">
                            <button class="button is-danger is-fullwidth" @click.prevent="removeOtherDoc(index)">
                                Remove
                            </button>
                        </o-table-column>
                    </template>
                </o-table>

                <button class="button is-fullwidth margin-top-md margin-bottom-md" @click.prevent="addOtherDoc">Add Doc</button>

                <o-field label="Via">
                    <o-select v-model="form.delivery" expanded name="delivery">
                        <option :value="null">Select from List</option>
                        <option v-for="service in postServices" :value="service" :key="service">
                            {{ service }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="CC">
                    <multicomplete v-model="cc" type="user" select-for-classic-form-name="cc[]" />
                </o-field>

                <div class="columns">
                    <div class="column">
                        <o-field label="Transmitted as checked below:">
                            <o-select v-model="form.reasons" multiple expanded native-size="5" name="reasons[]">
                                <option v-for="reason in reasons" :value="reason" :key="reason">
                                    {{ reason }}
                                </option>
                            </o-select>
                        </o-field>
                    </div>
                    <div class="column">
                        <o-field label="Comments:">
                            <o-input type="textarea" v-model="form.reason_comment" expanded name="reason_comment" />
                        </o-field>

                        <div class="field">
                            <o-radio v-model="form.address_source" native-value="company" name="address_source">Use company address</o-radio>
                        </div>
                        <div class="field">
                            <o-radio v-model="form.address_source" native-value="contact" name="address_source">Use contact address</o-radio>
                        </div>
                    </div>
                </div>

            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click.prevent="$parent.$parent.$emit('update:active', false)">Close</button>
                <button type="submit" class="button is-primary" v-submit="submitting">Create Transmittal PDF</button>
            </footer>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Multicomplete from './../../../../components/Multicomplete'

    export default {
        props: ['contact', 'project'],

        components: {
            Multicomplete
        },

        computed: {
            ...mapGetters(['applicationsByProjectId', 'applicationName', 'filesByProjectId']),

            applications() {
                return this.applicationsByProjectId(this.project.id)
            },

            files() {
                return this.filesByProjectId(this.project.id)
            }
        },

        data() {
            return {
                submitting: false,

                cc: [],
                a: [],
                form: {
                    docs: [],
                    other_docs: [],
                    delivery: null,
                    reasons: [],
                    reason_comment: '',
                    cc: [],
                    address_source: 'company'
                },

                docs: [
                    'Attached',
                    'Under Separate Cover',
                    'Forms for Signature',
                    'Marked up Plans',
                    'Plans',
                    'Samples',
                    'Copy of letter',
                    'Checks',
                    'Other',
                ],

                reasons: [
                    'For approval',
                    'For your use',
                    'As requested',
                    'For review and comment',
                    'Other'
                ],

                postServices: [
                    'USPS',
                    'UPS',
                    'FedEx',
                    'Hand Deliver',
                    'Messenger',
                ]
            }
        },

        mounted() {
            // pull address from the contact if it has an address
            let c = this.contact
            this.form.address_source = c.address_1 && c.city && c.state && c.zip ? 'contact' : 'company'
        },

        methods: {
            addOtherDoc() {
                this.form.other_docs.push({
                    copies: 1,
                    no: null,
                    file_id: null,
                    description: null
                })
            },

            removeOtherDoc(index) {
                this.form.other_docs.splice(index, 1)
            },

            handleFormSubmit() {
                this.submitting = true

                setTimeout(() => {
                    this.submitting = false
                }, 4500)
            }
        }
    }
</script>